import React, { useState, FormEvent } from "react";
import { CheckCircle, Download, ArrowRight, User, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import log from "../../../assets/images/mockup2.png";

export default function WealthMethodLeadMagnetOptin() {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      alert(
        `Thank you ${firstName}! Check your email for the W.E.A.L.T.H Method Starter Kit.`
      );
      setFirstName("");
      setEmail("");
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-green-50 overflow-y-auto">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="grid gap-y-6 lg:grid-cols-2 lg:gap-x-8">
          {/* Headline & Subheadline */}
          <div className="space-y-3 lg:space-y-4">
            <h4 className="text-sm font-semibold text-emerald-600 uppercase">
              Free PDF Guide
            </h4>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 leading-snug">
              The 6 Step System{" "}
              <span className="text-emerald-600">Busy People </span> {" "}Are Using{" "}
              <span className="text-yellow-600">
                To Make ₦700k+ Online Without Any Special Tech Skills
              </span>
            </h1>
            <p className="text-base text-gray-700">
              Get the{" "}
              <span className="font-semibold text-emerald-600">
                only proven system
              </span>{" "}
              that takes you from zero products and zero customers to profitable
              digital products and loyal buyers—no tech skills, no coding, no
              confusion.
            </p>
          </div>

          {/* Form */}
          <div className="w-full">
            <div className="bg-white rounded-2xl shadow p-6 sm:p-8">
              <div className="flex justify-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full flex items-center justify-center">
                  <Download className="w-6 h-6 text-white" />
                </div>
              </div>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="First name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  />
                </div>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <input
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full flex items-center justify-center space-x-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-medium text-lg py-3 rounded-lg transition"
                >
                  {isSubmitting ? (
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <Download className="w-5 h-5" />
                  )}
                  <span>{isSubmitting ? "Sending..." : "Send me the Guide"}</span>
                  {!isSubmitting && <ArrowRight className="w-5 h-5" />}
                </button>
              </form>
              <p className="mt-3 text-xs text-gray-500 text-center">
                🔒 Your info is secure. No spam.
              </p>
            </div>
          </div>
        </div>

        {/* Additional Benefits Section (image + text side by side) */}
        <section className="mt-10 flex flex-col md:flex-row items-center md:items-start gap-6 px-4">
          {/* Image Container */}
          <div className="w-full md:w-1/3 flex-shrink-0">
            <img
              src={log}
              alt="Wealth Method Preview"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>

          {/* Text Container */}
          <div className="w-full md:w-2/3">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Plus, when you download the guide, you’ll discover how to:
            </h2>
            <ul className="space-y-3">
              {[
                "Create High‑Demand Digital Products under 48 Hours",
                "Find Your Perfect Customers Who Can't Wait to Buy",
                "Build a Money‑Making System That Works While You Sleep",
                "Create Lasting Wealth That Grows Beyond You",
              ].map((benefit) => (
                <li key={benefit} className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-1 mr-2" />
                  <span className="text-gray-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Legal Footer Links */}
        <div className="border-t border-gray-200 mt-8 pt-6 text-center text-xs text-gray-500">
          <p className="space-x-2">
            <Link to="/privacy-policy" className="hover:text-gray-700">
              Privacy Policy
            </Link>
            <span>·</span>
            <Link to="/terms-of-service" className="hover:text-gray-700">
              Terms of Service
            </Link>
            <span>·</span>
            <Link to="/cookie-policy" className="hover:text-gray-700">
              Cookie Policy
            </Link>
            <span>·</span>
            <Link to="/unsubscribe" className="hover:text-gray-700">
              Unsubscribe
            </Link>
          </p>
          <p className="mt-2">
            By signing up, you agree to receive occasional emails about this
            guide and future offers. You can unsubscribe at any time.
          </p>
        </div>
      </div>
    </div>
  );
}
